import React from 'react';
import PropTypes from 'prop-types';

import { cartItemsArrayPropTypes } from 'helpers/propTypes';

import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/icons/List';

import './CartSummary.scss';
import { getLocalStorage } from 'helpers/storage';
import { formatCurrencyARS } from 'helpers/currency';

const CartSummary = (props) => {
  const {
    items, shippingText, subtotal, coupon, subTotEnv, 
    cuotasMP, onOpenPaymentModal, showMPButton, paymentMethods,
  } = props;
  const hasInstallments = cuotasMP && cuotasMP.length > 0;
  const discount = getLocalStorage('discount');
  const subtotalValue = parseFloat(subtotal);
  const percentageOrAmount = coupon?.percentage
    ? (coupon.percentage / 100) * subtotal
    : (coupon?.amount || 0);
  const totalValueWithDiscount = (discount - percentageOrAmount) > 0
    ? discount - percentageOrAmount
    : 0;
  const totalValueWithoutDiscount = (subtotal - percentageOrAmount) > 0
    ? subtotal - percentageOrAmount
    : 0;
  const totalValueWithPercetage = subtotal - percentageOrAmount;

  const existsRestrictedMethods = Array.isArray(paymentMethods) && paymentMethods.some(m => !m.allow_discount);

  const paymentRows = Array.isArray(paymentMethods)
    ? paymentMethods.map(m => {
        const methodPercent = typeof m.percent === 'number' ? m.percent : 0;
        const label = m.name || m.code || 'Medio de pago';
        const baseAuto = (m.allow_discount && discount !== null) 
            ? parseFloat(discount) 
            : subtotalValue;

        const baseConCupon = Math.max(0, baseAuto - percentageOrAmount);
        const finalAmount = +((baseConCupon + subTotEnv) * (1 - methodPercent)).toFixed(2);
        
        return { 
            key: m.code || label, 
            label, 
            percent: methodPercent, 
            amount: finalAmount,
            isAutoAllowed: !!m.allow_discount 
        };
      })
    : [];

  const findProductWholesale = (id, item) => {
    const product = item.product_wholesaler.find((prod) => prod.id === id);
    return product.price * product.quantity;
  };

  const findIDProductWholesale = (subItem, item) => {
    const values = Object.values(subItem);
    const firstArray = values[0];
    const firstObject = firstArray[0];
    const { id } = firstObject.wholesale;
    if (id > 0) {
      const product = item.product_wholesaler.find((prod) => prod.id === id);
      return `Precio por ${firstObject.wholesale.quantity} - ${formatCurrencyARS(product.price * product.quantity)}`;
    }
    return `Precio - ${formatCurrencyARS(item.price)}`;
  };

  const renderDescriptions = (descriptions, colors, item, descriptionId) => {
    const color = colors.find(
      ({ stock_description_id }) => stock_description_id === Number(descriptionId),
    );
    return !!descriptions.length && (
      <li key={`${item.id}-${descriptionId}`}>
        <strong style={{ color: color.stock_descriptions.rgb }}>
          {color.stock_descriptions.name}
        </strong>
        {' - '}
        {descriptions.map(({ description, quantity: amount }, index) => (
          <span className="cart-item-description" key={`${item.id}-${description.id}`}>
            {description.id === color.id ? amount : `${description.stock_descriptions.name}: ${amount}${index === descriptions.length - 1 ? '' : ', '}`}
          </span>
        ))}
      </li>
    );
  };
  return (
    <div className="container" data-testid="cart-summary-component">
      <div className="row">
        <div className="form-container">
          <Avatar className="avatar">
            <List />
          </Avatar>
          <h4>Resumen de la compra</h4>
          <div className="summary-items">
            {items.map(({
              item, quantity, colors, subItems, subItemsDescriptions,
            }) => !!item && (
              <div key={item.id}>
                <div className="d-flex flex-row">
                  <div className="summary-item-image">
                    <img src={item.image1} alt={item.name} />
                  </div>
                  <div className="summary-item-info">
                    <ul>
                      <li className="d-flex flex-row">
                        <span className="summary-item-title">
                          {item.name}
                        </span>
                      </li>
                      <li>
                        <span className="summary-item-description">
                          {item.description}
                        </span>
                      </li>
                      {colors && (
                        <div className="descriptions-container-cart-summary">
                          {Object.values(subItemsDescriptions || {}).some((value) => typeof value === 'object' && Object.keys(value).length > 0)
                            && (
                              <>
                                {Object.values(subItemsDescriptions || {}).map((subItemDescription) => (
                                  <>
                                    {Object.keys(subItemDescription).length > 0
                                      && (
                                        <div className="precios-container">
                                          <span className="title-description search-item">{findIDProductWholesale(subItemDescription, item)}</span>
                                          {Object.entries(subItemDescription).map(
                                            ([descriptionId, descriptionArray]) => renderDescriptions(
                                              descriptionArray, colors, item, descriptionId,
                                            ),
                                          )}
                                        </div>
                                      )}
                                  </>
                                ))}
                              </>
                            )}
                        </div>
                      )}
                      {
                        subItems?.length > 0 && (
                          <>
                            {subItems.map((subItem) => (
                              <>
                                <div className="precios-container">
                                  <span className="title-description search-item">
                                    {subItem.wholesale.id > 0 ? `Precio por ${subItem.wholesale.quantity} -` : 'Precio -'}
                                    {' '}
                                  </span>
                                  <span className="summary-item-price price-text">
                                    {formatCurrencyARS(subItem.wholesale.id > 0 ? findProductWholesale(subItem.wholesale.id, item) : item.price)}
                                  </span>
                                </div>
                                <li>
                                  <span className="summary-item-title">
                                    {`Cantidad: ${subItem.quantity}`}
                                  </span>
                                </li>
                              </>
                            ))}
                          </>
                        )
                      }
                      {!(item.product_wholesaler.length > 0)
                        && (item.stock_product_descriptions.length === 0) && (
                          <>
                            <div className="precios-container">
                              <span className="title-description search-item">
                                Precio -
                              </span>
                              <span className="summary-item-price price-text">
                                {(item.product_wholesaler.length === 0) && formatCurrencyARS(item.sale || item.price)}
                                {!!item.sale && (item.product_wholesaler.length === 0) && <span>{formatCurrencyARS(item.price)}</span>}
                                {(item.product_wholesaler.length > 0) && formatCurrencyARS(item.price)}
                              </span>
                            </div>
                            <li>
                              <span className="summary-item-title">
                                {`Cantidad: ${quantity}`}
                              </span>
                            </li>
                          </>
                        )}
                    </ul>
                  </div>
                </div>
                <div className="separator" />
              </div>
            ))}
          </div>
          <ul className="summary-subtotal">
            <li>
              Subtotal:
              {discount === null
                ? (
                  <span className="float-right">
                    {formatCurrencyARS(subtotalValue)}
                  </span>
                )
                : (
                  <del className="float-right">
                    {formatCurrencyARS(subtotalValue)}
                  </del>
                )}
            </li>
            <li>
              Descuentos
              <span className="float-right">
                {
                  !coupon ? (
                    discount != null
                    && (
                      <span style={{ color: '#28a745', textAlign: 'right', display: 'block' }} >
                        {getLocalStorage('percentage')}% OFF 
                        {existsRestrictedMethods && <small style={{ display: 'block', fontSize: '10px', color: '#666' }}>(Según medio de pago)</small>}
                      </span>
                    )
                  ) : (
                    <>
                      {discount != null ? (`CUPÓN ${coupon.percentage ? (`${coupon.percentage}%`) : (`$${coupon.amount} y ${getLocalStorage('percentage')}%:`)} `) : (`CUPÓN ${coupon.percentage ? (`${coupon.percentage}%`) : (`$${coupon.amount}`)} `)}
                      {existsRestrictedMethods && discount != null && <small style={{ display: 'block', fontSize: '10px', color: '#666', textAlign: 'right' }}>(Automático solo en medios habilitados)</small>}
                    </>
                  )
                }
              </span>
            </li>
            <li>
              Costo de envío:
              <span className="float-right">
                {shippingText}
              </span>
            </li>
            <div className="separator" />
            <li>
              Total:
              {
                discount === null
                  ? (
                    <span className="float-right">
                      {formatCurrencyARS(totalValueWithoutDiscount + subTotEnv)}
                    </span>
                  )
                  : (
                    <span className="float-right">
                      {
                        coupon?.percentage ? (
                          formatCurrencyARS(totalValueWithPercetage + subTotEnv)
                        ) : (
                          formatCurrencyARS(totalValueWithDiscount + subTotEnv)
                        )
                      }
                    </span>
                  )
              }

            </li>
            {hasInstallments && showMPButton && (
              <div 
                className="pt-payment-methods-link" 
                onClick={onOpenPaymentModal}
                style={{ marginTop: '8px', cursor: 'pointer', color: '#3483fa', fontSize: '14px', fontWeight: '500' }}
              >
                Ver bancos con cuotas sin interés
              </div>
            )}

            {!!paymentRows.length && (
              <div style={{ marginTop: 16, padding: '12px', background: '#f8f9fa', borderRadius: '8px' }}>
                <div style={{ fontWeight: 600, marginBottom: 8, fontSize: '13px', borderBottom: '1px solid #ddd' }}>
                    Totales según medio de pago:
                </div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {paymentRows.map(r => (
                    <li key={r.key} style={{ padding: '6px 0', borderBottom: '1px solid #eee' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>
                          {r.label}
                          {r.percent > 0 && <small style={{ color: '#28a745', marginLeft: '5px' }}>(-{(r.percent * 100).toFixed(0)}%)</small>}
                        </span>
                        <strong>${r.amount.toLocaleString('es-AR')}</strong>
                      </div>
                      
                      {/* ACLARACIÓN ESPECÍFICA POR CADA FILA */}
                      {!r.isAutoAllowed && discount !== null && (
                        <div style={{ fontSize: '10px', color: '#666', fontStyle: 'italic' }}>
                          * No incluye descuento automático por volumen.
                        </div>
                      )}
                      {r.isAutoAllowed && discount !== null && (
                        <div style={{ fontSize: '10px', color: '#28a745' }}>
                          * Incluye descuento automático aplicado.
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

CartSummary.defaultProps = {
  coupon: null,
};

CartSummary.propTypes = {
  items: cartItemsArrayPropTypes.isRequired,
  shippingText: PropTypes.string.isRequired,
  subtotal: PropTypes.number.isRequired,
  coupon: PropTypes.shape({
    id: PropTypes.number.isRequired,
    percentage: PropTypes.number.isRequired,
    amount: PropTypes.number.isRequired,
  }),
};

export default CartSummary;
